import React from 'react';
import './Warning.css';
const Warning = () => {
  return (
    <div className='warningContainer'>
      <h1 className="warning_title">Location Error</h1>
      <p className="message">Please check you location!</p>
    </div>
  );
};

export default Warning;
